import { Flex, Text } from '@chakra-ui/react'
import Stonks from '../../../../../assets/Stonks.svg'
import { iCompetenciaPDI } from '../../../../../interfaces'

interface iRecomendacaoProps {
  pos: number
  recomendacao: iCompetenciaPDI
}

export const Recomendacao: React.FC<iRecomendacaoProps> = ({ recomendacao, pos }) => {
  return (
        <Flex width={'100%'} height={'100%'}>
            <Flex borderBottomLeftRadius={'.25rem'} pos={'relative'} borderTopLeftRadius={'.25rem'} background={'var(--c2)'}>
                <Text as={'h4'} pos={'absolute'} top={'0'} fontWeight={'900'} left={'0'} style={{ padding: '.325rem 0 0 .5rem' }}>{pos}°</Text>
                <Flex width={'8rem'} fontSize={'.813rem'} textAlign={'center'} justifyContent={'center'} alignItems='center' flexDir={'column'} padding={'1rem .325rem 1rem .325rem'}>
                    <Flex width={'3rem'}>
                        <img style={{ width: '100%', height: '100%' }} src={recomendacao.avatar} />
                    </Flex>
                    <strong>{recomendacao.nome.replace('/', ' / ')}</strong>
                </Flex>
            </Flex>
            <Flex flexDir={'column'} gap='.75rem' borderBottomRightRadius={'.25rem'} borderTopRightRadius={'.25rem'} padding={'1rem'} background={'var(--Green2)'} flex={'1'}>
                <Text fontSize={'0.75rem'} lineHeight={'115%'} fontWeight={'400'} color='white'>{recomendacao.pergunta}</Text>
                <Flex height={'100%'} alignItems={'end'} justifyContent='space-between'>
                    <Flex color={'white'} flexDir={'column'}>
                        <h3>{recomendacao.colaboradores}</h3>
                        <Text fontWeight={'400'} lineHeight={'.875rem'} fontSize={'.875rem'}>Colaboradores</Text>
                    </Flex>
                    <Flex height='1rem'>
                        <img src={Stonks} />
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
  )
}
